import { render, staticRenderFns } from "./PersonPage.vue?vue&type=template&id=51a893f8&scoped=true&"
import script from "./PersonPage.vue?vue&type=script&lang=js&"
export * from "./PersonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a893f8",
  null
  
)

export default component.exports